<div class="snackbar-container">
  <div class="o-grid__item col-1 col-sm-1">
    <img src="/assets/img/checkbox-checked-round-green.svg" />
    <label class="c-notification-sucess"></label>
  </div>
  <div class="o-grid__item col-7 col-sm-7">
    <h4>{{ data.header }}</h4>
    <p>{{ data.message }}</p>
  </div>
  <div class="o-grid__item col-2 col-sm-2">
    <a routerLink="{{ data.link }}">View</a>
  </div>
  <div class="o-grid__item col-2 col-sm-2 close-btn-container">
    <a (click)="snackBarRef.dismiss()">
      <img
        class="close-icon"
        src="/assets/img/close-dark.svg" />
    </a>
  </div>
</div>
